export const SIGNUP_TYPES = {
  MODAL: "modal",
  FULLPAGE: "full_page",
};
